<!--订单发起采购页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p v-if="uname"><span>操作人：</span>{{uname}}<span>正在操作</span><span @click="unlock" style="color: blue;cursor: pointer">&nbsp;解除锁定</span>
      </p>
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <!--<p v-if="controlData.isjiaji==1" style="color:red;margin-left: 20px;font-weight:bold; "><span>加急</span>&nbsp;&nbsp;<span>期望时间：</span>{{controlData.wantarrivaltime}}-->
      <!--</p>-->
      <div v-if="linecredit&&linecredit!=0" :style="{color:linecredit<0?'red':'blue'}" style="margin-left: 20px;font-weight:bold;float:left ">
        <span>信用额度：</span>{{linecredit}}
      </div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">客户名称：</td>
          <td width="200">{{controlData.customerserial}}  {{controlData.customername}}</td>
          <td align="right" width="80">客户地址：</td>
          <td width="300">{{controlData.deliveryaddress}}</td>
          <td width="140">
            <!--<el-tag v-if="ssodirectsend" effect="dark" type="warning">直发客户</el-tag>-->
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">供应商：</td>
          <td style="font-size: x-large"><b>{{controlData.pcustomer}}</b></td>
          <td align="right"  v-if="!ssotoken">供应商单号：</td>
          <td v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum"
                      onfocus="this.select()"
                      style="width: 155px"></el-input>
          </td>
        </tr>
        <tr class="noborder" v-if="usebomSeed.length>0">
          <td align="right">白包商品：</td>
          <td colspan="4">
            <el-table
            :data="usebomSeed"
            size="mini" border
            style="width: 100%;">
            <el-table-column label="产品编码" align="left" header-align="center" :show-overflow-tooltip="true" width="100">
              <template slot-scope="scope">
                {{ scope.row.seedcode }}
              </template>
            </el-table-column>
            <el-table-column label="产品名称" align="left" header-align="center" width="300" >
              <template slot-scope="scope">
                {{ scope.row.seedname }}
              </template>
            </el-table-column>
            <el-table-column label="白包" align="left" header-align="center">
              <template slot-scope="scope">
                <el-radio v-model="scope.row.checkcode" v-for="item in scope.row.bom" @change="getStorenumber(item.seedcode);"
                          :key="item.seedcode" :label="item.seedcode">{{item.seedname}}</el-radio>
              </template>
            </el-table-column>
          </el-table>
          </td>
        </tr>
      </table>
      <table :class="!item1.checked?'gray1':''" v-for="(item1,indextable) in tableData"
             :style="!item1.checked?'display: none;':''"
             style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder">
          <td align="left" width="60">销售单号：</td>
          <td align="left" width="150">{{item1.erpserial}}</td>
          <td align="left" width="80">下单日期：</td>
          <td align="left" width="150">{{item1.adddate}}</td>
          <td align="left" width="80"></td>
          <td align="left" width="150"></td>
        </tr>
        <tr>
          <td colspan="7" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0"
                   style="border-collapse:collapse;width:100%;fontSize:'18px'"
                   class="query-table">
              <tr>
                <td v-if=" item !='unitguid'&&item !='packagesize'&&item !='关联产品'&&item!='subseedcode'" style="text-align: center"
                    v-for="item in item1['column']">
                  <span v-if="item!='seedcode'"> {{item}}</span>
                  <span v-else-if="item=='seedcode'">编码</span>
                </td>
                <td  style="text-align: center" v-for="stockRow in jxcstoreData" v-if="stockRow.hasStore">{{stockRow.cangkuname}}</td>
                <td  style="text-align: center" v-if="showsupplystore">供应商</td>
              </tr>
              <tr v-for="(item,index) in item1['billmap']" style="cursor:pointer;">
                <td :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                    v-for="(ob,index) in item" v-if="checkShow(ob)">
                  <span v-for="value in ob" >{{value}}</span>
                  <!--<div v-for="(value,i) in ob" v-if="i=='产品名称'" v-html="getGuanLGoods(item)"></div>-->
                  <!--<span v-for="value1 in ob" v-if="index==item.length-2">-->
                    <!--<input @blur="changnum(item,item1)" type="text" v-model="ob['采购数量']" style="width:70px;"-->
                           <!--disabled="disabled"/></span>-->
                </td>
                <td  style="text-align: center" v-for="stockRow in jxcstoreData" v-if="stockRow.hasStore">
                <div v-html="storeHtml(stockRow,item)"></div>
                </td>
                <td  style="text-align: center" v-if="showsupplystore"><div v-html="supplystoreHtml(item)"></div></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="6" style="padding-top: 10px;padding-bottom: 10px;text-align: left;">
            <el-input  type="textarea" :rows="2" style="width: 70%;" v-model="moreremark" placeholder="填写给供应商的备注信息"></el-input>
            <el-checkbox v-model="edging" label="供应商代割边" border v-if="ssotoken&&ssotoken.startsWith('http')&&item1['billmap'].length<=3"></el-checkbox>
            <div v-html="getLiuYan(item1.remark,item1)"></div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="border:none">
            <table>
              <tr v-for="item in item1['formpropertyData']">
                <td align="left" style="padding-left: 0px;padding-right: 0px;" width="160"
                    v-for="(item2,index) in item">
                  <span style="width:80px;display: inline-block;text-align: right">{{index+"："}}</span>
                  <span style="width:70px;display: inline-block;text-align: left">{{item2}}</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button  style="float: left" :loading="loading" v-if="btnupdatevisible&&dialogSeeVisible&&!uname&&showbatch&&ssotoken" @click="saveDataNoESS()">
        确认采购（线下联系供应商下单）
      </el-button>
      <span style="color: #20A0FF">收货仓库：</span>
      <el-select v-model="controlData.cangkucode" placeholder="请选择仓库"  @change="changename" style="width: 140px">
        <el-option
          v-for="item in jxcstoreData"
          :key="item.cangkucode"
          :label="item.cangkuname"
          :value="item.cangkucode">
        </el-option>
      </el-select>
      <el-button type="primary" :loading="loading" v-if="btnupdatevisible&&dialogSeeVisible&&!uname&&showBuyButton" @click="saveData(false)">
        确认采购
      </el-button>
      <el-button type="warning" :loading="loading" v-if="ssodirectsend&&ssotoken&&btnupdatevisible&&dialogSeeVisible&&!uname&&showBuyButton" @click="saveDataToCus(false)">
        确认采购（直发客户）
      </el-button>
      <el-button @click="cancelClick()">取 消</el-button>
    </div>
    <BuyorderDetail ref="BuyorderDetail"></BuyorderDetail>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <BuyfromEssilor ref="BuyfromEssilor" @afterEssilorBuy="afterEssilorBuy" @saveDataNoESS="saveDataNoESS" @autoNext="autoNext" :showTPD="showTPD"  :buytype="'buy&sale'"></BuyfromEssilor>
  </el-dialog>
</template>

<script>

  import {buyorderdetail} from '@/api/set/csagreement';
  import {getBomslist} from  '@/api/set/jxcgooddetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {login, urlOrder,createOrder,backOrder,supplystoreNum,needsupplystore} from '@/api/ossi';
  import BuyfromSupplyer from './BuyfromSupplyer';
  import {getRemark} from '@/plugin/ordercommon'
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import {getDuiZhangCus} from '@/api/voucher/accountresultbz';
  import {checkModuleRight} from '@/api/login'
  import {isHaveRight} from '@/api/set/authorityset'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveData, getListData, lockremove} from '@/api/set/handlelog';
  import BuyfromEssilor from '@/components/testorder/buyagreement/BuyfromEssilor'
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersave, jxcstorelist
  } from '@/api/set/csagreement';

  export default {
    name: 'BuyorderEdit',
    data() {
      return {
        showTPD:true,
        loading: false,
        showBuyButton:true,
        xiaotuan:false,
        showbatch:false,
        flage: true,//数量选择区分显示列
        ssotoken: "",
        mySystem:false,
        fengongscangku:false,
        website:"",
        ssobuydetail: "",
        ssodirectsend:"",
        ssodirectbutton:false,
        edging:false,
        totalnumber:1,
        dialogSeeVisible: false,
        btnupdatevisible: false,
        linecredit:'',
        lock: false,//锁定订单
        formLabelWidth: '120px',
        groupguid: '',
        seedcode: "",
        remark: '',
        moreremark:'',
        usebomSeed:[],
        needstock:false,
        bomSet:[],
        cangkucode: '',
        cangkuname: '',
        cstagreements: [],
        independentserial: '',
        tableData: [
          {column: []},
        ],
        tableData1: [],
        unitguid: "",
        column: [],
        controlData: {},
        stocknums:[],
        showtitle1: "none",
        jxcstoreData: [],
        erpserial: '',
        uname: '',//操作人
        userInfoModel: '',//当前缓存
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        bn: '',
        formpropertyData: [],//公共参数数组
        parameter: {},//公共参数
        showsupplystore:false,
        supplystore:[],//供应商库存
      }
    },
    props: {
      isauto:{
        default: false
      },
    },
    methods: {
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      getGuanLGoods(rows) {
        var goods = this.getMapValue(rows, '关联产品');
        if (goods)
          return '<div style="float: left;padding-left: 30px">' + goods + '</div>'
        return '';
      },
      checkShow(ob) {
        for (let key in ob) {
          if (key == 'unitguid' || key == 'packagesize'||key=='关联产品'||key=='subseedcode') {
            return false
          }
        }
        return true;
      },
      //取消
      cancelClick() {
        this.dialogSeeVisible = false
      },
      //采购成功后解除锁定
      unlock() {
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          this.lock = true
          this.uname = ''
          //锁定功能(控制发起采购按钮)
          this.handlelog('申请采购');
        })
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = casestepname == '申请采购' ? 0 : 1;
        handlelog.insub = casestepname == '申请采购' ? 0 : 1;
        handlelog.totalnumber=this.totalnumber;
        handlelog.casestepname = casestepname
        if (this.controlData.cangkuname) {
          handlelog.remark = '入' + this.controlData.cangkuname
        }
        saveData(handlelog).then(response => {});
      },
      getTitle() {
        let result = this.userInfoModel.tenantname + "采购订单"
        return result
      },
      changnum(ob) {
        let res = /^[+]{0,1}(\d+)$/
        let num;
        let num1;
        var ob1 = null
        for (let i in ob) {
          if (typeof ob[i]['数量'] != "undefined") {
            num = ob[i]['数量']
          }
          if (typeof ob[i]['采购数量'] != "undefined") {
            ob1 = ob[i]
            num1 = ob[i]['采购数量']
          }
        }

        if (!res.test(num1)) {
          ob1["采购数量"] = ""
          this.$message({
            message: "请输入正确的数字",
            type: 'error'
          })
        } else {
          if (num < num1) {
            ob1["采购数量"] = ""
            this.$message({
              message: "采购数量不能大于购买数量",
              type: 'error'
            })
          }
        }
      },
      getLiuYan(remark,rows) {
        if (remark && remark.indexOf('"type":"割边"') > -1 && rows['billmap'].length <= 3) {
          this.edging = true;
        }
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      autoNext(){
        this.$emit('bindGrid');
      },
      saveDataNoESS(){
        // this.moreremark=this.moreremark+' '+'拆成2片推送';
        this.saveData(true);
      },
      saveDataToCus(userssotoken) {
        this.ssodirectbutton=true;
        this.saveDataBein(userssotoken);
      },
      saveData(userssotoken) {
        this.ssodirectbutton=false;
        this.saveDataBein(userssotoken);
      },
      saveDataBein(userssotoken) {
        if (!this.controlData.cangkucode) {
          this.$message({
            type: 'warning',
            duration: 1500,
            message: '仓库必选!'
          });
          this.loading = false
          return
        }
        this.bomSet=[];//选择的白包商品
        var bomseedcode='';
        if(this.usebomSeed.length>0){
          for(let i in this.usebomSeed){
            if(!this.usebomSeed[i].checkcode){
              this.$message({
                message: "请选择关联的白包商品",
                type: 'error'
              })
              this.isDisable = false
              return;
            }

            var bomseedname='';
            for(let j in this.usebomSeed[i].bom) {
              if (this.usebomSeed[i].bom[j].seedcode == this.usebomSeed[i].checkcode)
                bomseedname = this.usebomSeed[i].bom[j].seedname;
            }
            this.bomSet.push({seedcode:this.usebomSeed[i].seedcode,seedname:this.usebomSeed[i].seedname
              ,bomseedcode:this.usebomSeed[i].checkcode,bomseedname:bomseedname});
            bomseedcode=this.usebomSeed[i].checkcode;
          }
        }

        if(userssotoken) {
          this.ssotoken = false;
        }
        if (this.ssotoken&&this.ssotoken.indexOf("supplier") > -1) {
          this.$refs.BuyfromEssilor.show(this.ssotoken, this.ssobuydetail, this.controlData,bomseedcode);
        } else if (this.ssotoken) {//需要向供应商发起采购
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          var remarkend='{"msg":"'+this.moreremark+'","date":"","uname":"客户单号","type":"客户留言"}';
          var buyRemark= '['+remarkend+']';
          if(this.ssodirectsend) {
            var saleArr = [];
            try{
              let saleRemark = JSON.parse(this.tableData[0].remark.replace(/\r\n/g,"").replace(/\n/g,"").replace(/\r/g,"").replace(/\t/g,"  "))
              for (let i in saleRemark) {
                if (saleRemark[i].type == '客户留言') {
                  saleArr.push(saleRemark[i]);
                }
              }
            }catch(ex) { }
            if (this.moreremark)
              saleArr.push({"msg": this.moreremark, "date": "", "uname": "单号", "type": "客户留言"});
            buyRemark = JSON.stringify(saleArr);
            this.ssodirectsend["weburl"] = urlOrder();
          }else {
            if (this.ssotoken.indexOf('http') > -1) {
              this.ssodirectsend = {
                linkman: ckInfo.applyby, linkmantel: ckInfo.tel, deliveryaddress: ckInfo.adressdetail
              };
            }
          }

          createOrder({
            parentguid: this.controlData.erpserial,
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            customerserial: this.controlData.customerserial,
            customername: this.controlData.customername,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: this.ssobuydetail,
            ssodirectsend: this.ssodirectsend&&this.ssodirectbutton ? JSON.stringify(this.ssodirectsend) : "",//存供应商直发信息
            edgingflag: this.edging ? '1' : '',
            remark: buyRemark,
          }, this.ssotoken,this.mySystem).then(response => {
            if (response.data.code == 0) {
              this.tracknum = response.data.erpserial;
              this.saveBuyData(response.data.price, '上游订单已生成，供应商号：' + this.tracknum, null,null);
            } else {
              if (response.data.groupguid) {//打开支付页面
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '生成订单并支付',
                  cancelButtonText: '暂不生成',
                  showClose:false,
                  type: 'warning'
                }).then(() => {
                  this.tracknum = response.data.erpserial;
                  this.saveBuyData(response.data.price, '上游订单已生成，供应商单号：' + this.tracknum+'，请尽快完成支付！',
                    response.data,null);
                }).catch(() => {
                  //撤销订单
                  backOrder({erpserial:response.data.erpserial.split(';')[0]}, this.ssotoken,this.mySystem).then(resDel =>{
                    this.loading = false
                  });
                });
              } else {
                this.$message({
                  message: response.data.msg ? response.data.msg : '提交的商品不存在！',
                  type: 'error'
                })
                this.loading = false
              }
            }
          });
        } else {
          this.saveBuyData(null, '保存成功！',null,null);
        }
      },
      afterEssilorBuy(buyInfo) {
        this.saveBuyData(null, '提交成功！', null, buyInfo);
      },
      saveBuyData(pricelist,message,paydetail,supplydetail) {
        if (!supplydetail&&JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
          if (!this.tracknum) {
            this.$message({
              type: 'error',
              duration: 1500,
              message: '请填写供应商单号!'
            });
            this.loading = false
            return
          }
        }
        this.tableData1=[];
        this.cstagreements=[];
        //取出对应的表单详情和数量
        for (let j in this.tableData) {
          for (let i = 0; i < this.tableData[j]['billmap'].length; i++) {
            var obj = this.tableData[j]['billmap'][i]
            let num = 0;
            let gysprice = 0;
            let seedcode;
            for (var keyObj in  obj) {
              for (var key in obj[keyObj]) {
                if (key == '数量') {
                  num = obj[keyObj]['数量']
                }

                if (key == 'seedcode') {
                  seedcode = obj[keyObj]['seedcode']
                  // if (pricelist) {
                  //   if(pricelist[seedcode]){
                  //     gysprice=pricelist[seedcode]
                  //   }
                  // }
                }
              }
            }

            let jxc = {
              unitguid: '',
              num: '',
              gysprice: gysprice,
            }
            if (num && num > 0) {
              jxc.unitguid = this.tableData[j]['billmap'][i][this.tableData[j]['billmap'][i].length - 1].unitguid
              jxc.num = num;
              if (jxc.unitguid)
                this.tableData1.push(jxc)
            }
          }
        }

        if (this.tableData1.length != 0) {
          buyodersave({
            jxcforms: JSON.stringify(this.tableData1),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.elinkman,
              linkmantel: this.controlData.elinkmantel,
              tracknum: this.tracknum.trim(),
              logisticstracknum: this.logisticstracknum.trim(),
              seedinfo: this.controlData.seedinfo,
              bomset: this.bomSet,
              moreremark:this.moreremark,
              bn: this.bn,
            }),
            cstagreements: JSON.stringify(this.cstagreements),
            supplydetail: supplydetail
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: message,
                type: 'success'
              })
              this.handlelog('以销定采');
              //采购成功后解除锁定
              this.unlock();
              this.$emit('bindGrid');

              if (pricelist && paydetail)//只能打开一个页面
                this.$refs.BuyfromSupplyer.show(this.ssotoken, this.website, paydetail, 'pay');
              else
                this.$emit('print');
              //this.lookbuyorderdetail(response.data.obj, 1)
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //
        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder)
        this.$refs.BuyorderDetail.show();
      },
      getStorenumber(seedcode) {
        for(let i in this.jxcstoreData){
          this.jxcstoreData[i].hasStore=false;
        }
        var pagesize=[];
        for(let i in this.controlData.billmap){
          var row=this.controlData.billmap[i].packagesize
          if(row) pagesize.push(row);
        }
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        getGoodsListWithStoreDetail({
          seedcode: seedcode,
          cangkucode: 'all',
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          packagesizelist:JSON.stringify(pagesize),
          nostock: 1,
          nolimit:1,
          notransfernum:1,
          nobuynum:1,
          warehouse: ''
        }).then(resStore => {
          this.stocknums = resStore.data.obj//库存片
          for (let i in this.jxcstoreData) {
            var cangkucode = this.jxcstoreData[i].cangkucode;
            for (let j in this.stocknums) {
              if (this.stocknums[j].cangkucode == cangkucode && (this.stocknums[j].subtractnum - this.stocknums[j].deliverying) > 0) {
                this.jxcstoreData[i].hasStore = true;
                break;
              }
            }
          }
        });
      },
      storeHtml(storeInfo,packageInfo){
        var seedcode='';
        var packagesize=''
        var number=0;
        var cangkucode=storeInfo.cangkucode;
        for(let i in packageInfo){
          for (var key in packageInfo[i]) {
            if (key == 'seedcode')
              seedcode = packageInfo[i][key];
            if (key == 'packagesize')
              packagesize = packageInfo[i][key];
            if (key == '数量')
              number = parseInt(packageInfo[i][key]);
          }
        }

        for(let i in this.stocknums){
          var row=this.stocknums[i];
          if(row.cangkucode==cangkucode&&packagesize&&row.packagesize==packagesize){
            if(row.subtractnum -row.deliverying>0) {
              if (row.subtractnum - row.deliverying >= number) {//数量充足
                return '<span style="color: red"><b>'+(row.subtractnum - row.deliverying)+'</b></span>';
              } else
                return row.subtractnum - row.deliverying;
            }
            break
          }
        }
        return '';
      },
      supplystoreHtml(packageInfo){
        var seedcode='';
        var packagesize=''
        var number=0;
        for(let i in packageInfo){
          for (var key in packageInfo[i]) {
            if (key == 'seedcode')
              seedcode = packageInfo[i][key];
            if (key == 'packagesize')
              packagesize = packageInfo[i][key];
            if (key == '数量')
              number = parseInt(packageInfo[i][key]);
          }
        }
        for(let i in this.supplystore){
          var row=this.supplystore[i];
          if(packagesize&&row.packagesize==packagesize&&row.seedcode==seedcode){
            if(row.subtractnum -row.deliverying>0) {
              if (row.subtractnum - row.deliverying >= number) {//数量充足
                return '<span style="color: red"><b>'+(row.subtractnum - row.deliverying)+'</b></span>';
              } else
                return row.subtractnum - row.deliverying;
            }
            break
          }
        }
        return '';
      },
      buyFromSupply(data) {
        this.showsupplystore = needsupplystore();
        if (this.ssotoken && this.ssotoken.indexOf('http') > -1) {
          return;
        }
        if(!this.showsupplystore) return;
        var seedcode = ';';
        var packagesize = ';';
        for (let i in data) {
          if (seedcode.indexOf(';' + data[i].seedcode + ';') == -1) {
            seedcode += data[i].seedcode + ';';
          }
          if (packagesize.indexOf(';' + data[i].packagesize + ';') == -1) {
            packagesize += data[i].packagesize + ';';
          }
        }
        supplystoreNum({seedcode: seedcode, packagesize: packagesize}, this.ssotoken,this.mySystem).then(response => {
          if (response.data.code == 0) {
            this.supplystore=response.data.obj;
          }
        });
      },
      initData(row, groupguid) {
        this.initForm()
        this.ssotoken="";
        this.website="";
        this.loading=true;
        this.linecredit=''
        this.ssobuydetail="";
        this.ssodirectsend="";
        this.erpserial = row.erpserial
        var needStoreNum=true;
        this.showsupplystore=false;

        this.needstock=false;//是备货商品
        var bomseedStr='';
        var storeseedcode="";
        this.usebomSeed=[]
        if (row.bn == '发起采购') {
          this.bn = 1
        } else if (row.bn == '通知仓库') {
          this.bn = 2
        }

        for (let i in row.jxcformdetailDOList) {
          if (row.jxcformdetailDOList[i].filltemplate == "40"||row.jxcformdetailDOList[i].filltemplate == "80") {
            this.flage = false;
          }
          if (row.jxcformdetailDOList[i].usebom == 1) {
            if ((';' + bomseedStr).indexOf((';' + row.jxcformdetailDOList[i].seedcode + ';')) == -1) {
              bomseedStr += row.jxcformdetailDOList[i].seedcode + ';';
              this.usebomSeed.push({
                seedcode: row.jxcformdetailDOList[i].seedcode,
                seedname: row.jxcformdetailDOList[i].seedname,
                checkcode:'',
                bom:[]
              });
            }
          }
          if(row.jxcformdetailDOList[i].nostock==1){
            this.needstock=true;
            storeseedcode=row.jxcformdetailDOList[i].seedcode;
          }
        }

        isHaveRight({rightguid: row.pcustomerserial, type: '001', flag: 1}).then(response => {//判断是否有采购权限，2018-10-25
            if (!response.data.obj) {
              this.$message({
                duration: 2000,
                type: 'error',
                message: '没有采购权限!'
              })
              this.btnupdatevisible = false
            } else {
              this.btnupdatevisible = true

              //检查信用额度
              if(row.paymethod.indexOf('按合同结算')>-1) {
                getDuiZhangCus({customerserial: row.customerserial}).then(resCredit => {
                  if (resCredit.data.code == 0) {
                    var useMoney = parseFloat(resCredit.data.obj) + parseFloat(row.htje | 0) + parseFloat(row.expressfee | 0);//已使用金额
                    this.linecredit = (parseFloat(resCredit.data.linecredit) - useMoney).toFixed(2);
                    if (useMoney > parseFloat(resCredit.data.linecredit) && !(resCredit.data.settingmoney == 99)) {//超额 不给发货
                      this.loading = true;
                      checkModuleRight({name: 'linecreditNobuy'}).then(reponse => {
                        if (reponse.data.code == 0) {
                          this.loading = false;
                        }
                      });
                    }
                  }
                })
              }
              //查询订单是否有人正在操作
              getListData({
                erpserial: this.erpserial,
              }).then(response => {
                this.lock = false;//是否有人锁定
                if (response.data.obj.length > 0) {
                  //当前登陆人与日志表uname不一致时锁定采购订单
                  //发起采购、通知仓库按钮会同时出现，只要有一个在操作需要锁定订单
                  for (let i = 0; i < response.data.obj.length; i++) {
                    if (response.data.obj[i].casestepname == '操作通知仓库' || response.data.obj[i].casestepname == '申请采购' || response.data.obj[i].casestepname == '操作通知加工') {
                      this.lock = true;
                      if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {
                        this.uname = response.data.obj[i].uname;
                        break;
                      }
                    }
                  }
                }
                //锁定功能(控制发起采购按钮),没有采购权限是不锁定订单
                if (!this.lock && this.btnupdatevisible) {
                  this.handlelog('申请采购');
                }
              })
            }
          })


        this.tableData1 = [];
        this.groupguid = groupguid
        this.unitguid = row.unitguid
        buyorderdetail({
          unitguid: row.unitguid,
          groupguid: this.groupguid,
          unitgroup: 3,
          pcustomerSerial: row.pcustomerserial
        }).then(response => {
          this.controlData = response.data.obj.detail;
          this.moreremark=this.controlData.erpserial;
          this.tableData = response.data.obj.goodsDetail;
          this.parameter = response.data.obj.parameter

          if(this.userInfoModel.tenantid=='d6d0f500-6c34-45e6-b206-b87c368e4469') {//找眼镜网仓库太多，只对依视路启用库存判断
            if (!response.data.obj.ssocode || response.data.obj.ssocode.indexOf("supplier") == -1) {
              needStoreNum = false;
            }
          }

          this.ssodirectsend=  response.data.obj.ssodirectsend?response.data.obj.ssodirectsend:"";
          if(response.data.obj.ssocode) {
            if (response.data.obj.ssocode.indexOf("supplier") > -1) {//直接向依视路供应商采购
              this.ssotoken = response.data.obj.ssocode;
              this.ssobuydetail = response.data.obj.ssobuydetail;
              this.loading = false;
            } else {
              //执行登录方法
              this.mySystem = response.data.obj.usesso == '2';
              login({
                idencode: response.data.obj.ssocode,
                tenantid: this.userInfoModel.tenantid
              }, this.mySystem).then(loginres => {
                if (loginres.data.code == 0) {
                  this.ssotoken = loginres.data.msg;
                  this.website = loginres.data.website;
                  this.ssobuydetail = response.data.obj.ssobuydetail;
                  this.loading = false;
                  if (this.isauto) {
                    this.saveData();//自动下单
                  }

                  //查供应商库存
                  this.buyFromSupply(this.controlData.billmap);
                } else {
                  this.showBuyButton=false;
                  this.ssotoken = loginres.data.msg;
                  this.$message({message: loginres.data.msg, type: 'error'})
                }
              });
            }
          }else{
            this.loading=false;
          }

          //对应的白包商品
          if(bomseedStr) {
            getBomslist({seedcode: bomseedStr,pcustomerserial:row.pcustomerserial}).then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.obj) {
                  for (var j in this.usebomSeed) {
                    if (this.usebomSeed[j].seedcode == response.data.obj[i].seedcode) {
                      this.usebomSeed[j].bom.push({
                        seedcode: response.data.obj[i].bomseedcode,
                        seedname: response.data.obj[i].seedname,
                      });
                    }
                  }
                }

                for (var j in this.usebomSeed){
                  if(this.usebomSeed[j].bom.length==1) {
                    this.usebomSeed[j].checkcode = this.usebomSeed[j].bom[0].seedcode;
                    if (needStoreNum)
                      this.getStorenumber(this.usebomSeed[j].checkcode);
                  }
                }
              }
            });
          }else {
            if (needStoreNum)
              this.getStorenumber(storeseedcode);
          }
          //解析参数
          this.tableData.forEach(o => {
            if (o.parametermap) {
              let biaoji = 0;
              o.formpropertyData = []
              for (let j in o.parametermap) {
                if (biaoji % 4 == 0) {
                  let temp = {}
                  temp[j] = o.parametermap[j]
                  o.formpropertyData.push(temp)
                } else {
                  o.formpropertyData[o.formpropertyData.length - 1][j] = o.parametermap[j]
                }
                biaoji++
              }
            }
          })

          if (this.jxcstoreData && this.jxcstoreData.length > 0) {
            // //没有仓库时 ，仓库默认第一个
            // if (!this.controlData.cangkucode) {
            //   this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
            //   this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
            // }
            var initCangKu = this.controlData.applybydserial;
            var showcangkucode = '';
            if (this.jxcstoreData.length > 0) {
              showcangkucode = this.jxcstoreData[0].cangkucode;
              if(this.fengongscangku) {
                for (let i in this.jxcstoreData) {
                  if (this.jxcstoreData[i].independentserial == initCangKu) {
                    showcangkucode = this.jxcstoreData[i].cangkucode;
                    break;
                  }
                }
              }
            }
            this.controlData.cangkucode=showcangkucode;
            this.changename(showcangkucode)
          }
          if (this.tableData.length > 0) {
            for (let g = 0; g < this.tableData.length; g++) {
              //取出表头
              let temparr = []
              let biaoji = 0
              this.column = []

              for (let i in this.tableData[g]['billmap']) {
                for (let j in this.tableData[g]['billmap'][i]) {
                  if (j == "R/L") {
                    biaoji = 1
                  }
                  if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "销售单号" && j != "采购数量" && j != "unitguid") {
                    temparr.push(j)
                  }
                }
              }
              //对表头排序

              if (biaoji == 1) {
                this.column.push("R/L")
              }
              this.column.push("seedcode")
              this.column.push("产品名称")
              if (this.flage) {
                this.column.push("球镜")
                this.column.push("柱镜")
                this.column.push("轴位")
              }
              this.column = this.column.concat(temparr)
              //this.column.push("销售单号")
              this.column.push("数量")
              // this.column.push("采购数量")
              this.column.push("unitguid")
              this.tableData[g]['column'] = this.column
              this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => this.column.map(o2 => {
                let ob = {}
                ob[o2] = o1[o2]
                return ob
              }))
              let istj = {
                "istj": true
              }
              //增加复选框是否选中
              if (row.unitguid == this.tableData[g].unitguid) {
                this.cstagreements.push(this.tableData[g].unitguid)
                this.$set(this.tableData[g], "checked", true)
                this.tableData[g]['billmap'].forEach(o => {
                  let count1 = ""
                  for (let i in o) {
                    if (typeof o[i]["数量"] != "undefined") {
                      count1 = o[i]["数量"]
                      this.totalnumber+=parseInt(count1)
                    }
                    if (typeof o[i]["采购数量"] != "undefined") {
                      o[i]["采购数量"] = count1
                      break;
                    }
                  }
                })
              } else {
                this.$set(this.tableData[g], "checked", false)
              }
            }
          }
        });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.showBuyButton=true;
        this.loading = false;
        this.logisticstracknum = ''
        this.tracknum = ''
        this.totalnumber=1;
        this.mySystem=false;
        this.bn = ''
        this.lock = false;
        this.controlData = {}
        this.cangkucode = ""
        this.edging=false;
        this.cangkuname = ""
        this.btnupdatevisible = false
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.uname = ''
        for(let i in this.jxcstoreData){
          this.jxcstoreData[i].hasStore=false;
        }
        this.stocknums=[]
      },

    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.xiaotuan=this.userInfoModel.tenantid=='aefbdd21-4ab9-45e5-8925-81060406693b';
      this.showbatch = true;// this.userInfoModel.mobile == '15250395939' || this.userInfoModel.mobile == '18951936669'|| this.userInfoModel.tenantid == 'e5682784-dbb7-4eba-939f-4c265092db1d';
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        for(let i in this.jxcstoreData){
          this.$set(this.jxcstoreData[i], "hasStore", false);
        }
      })
    },
    components: {
      BuyorderDetail,
      BuyfromSupplyer,
      BuyfromEssilor
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderEdit.vue